import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faTachometerAlt,
    faCoins,
    faGlobe,
    faUser,
    faExchangeAlt,
    faFile,
    faWrench,
    faExternalLinkAlt,
    faInfoCircle,
    faClipboardList,
    faPlusCircle,
    faMinusCircle,
    faCopy,
    faArrowUp,
    faPassport,
    faLayerGroup,
    faUniversity,
    faArrowDown,
    faPlug,
    faServer,
    faDatabase,
    faHdd,
    faWifi,
    faTerminal,
    faTasks,
    faEnvelope,
    faSyncAlt,
    faCreditCard,
    faCodeBranch,
    faSignOutAlt,
    faClock,
    faCheck,
    faExclamation,
    faFlag,
    faGift,
    faHandHoldingUsd,
    faCircle,
    faShieldAlt,
    faCaretDown,
    faTicketAlt,
    faNewspaper,
    faUserFriends,
    faExclamationCircle,
    faEye,
    faMoneyBill
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Add icons to library
library.add(
    faTachometerAlt,
    faCoins,
    faGlobe,
    faUser,
    faWrench,
    faExchangeAlt,
    faExternalLinkAlt,
    faInfoCircle,
    faFile,
    faClipboardList,
    faPlusCircle,
    faMinusCircle,
    faCopy,
    faArrowUp,
    faArrowDown,
    faPassport,
    faLayerGroup,
    faUniversity,
    faPlug,
    faServer,
    faDatabase,
    faHdd,
    faWifi,
    faTerminal,
    faTasks,
    faEnvelope,
    faSyncAlt,
    faCreditCard,
    faCodeBranch,
    faSignOutAlt,
    faClock,
    faCheck,
    faExclamation,
    faCaretDown,
    faCircle,
    faFlag,
    faGift,
    faHandHoldingUsd,
    faShieldAlt,
    faTicketAlt,
    faNewspaper,
    faUserFriends,
    faEye,
    faMoneyBill,
    faExclamationCircle
);

// Export FontAwesomeIcon for use in app.js
export { FontAwesomeIcon };
